module.exports = "././img/QLD_CoA_Website_LOGO-black.png";


//////////////////
// WEBPACK FOOTER
// ../assets/img/QLD_CoA_Website_LOGO-black.png
// module id = 776
// module chunks = 0